import React from 'react';
import { MarketingHeader } from './MarketingHeader';
import { MarketingFooter } from './MarketingFooter';
import { TickerTape } from './TickerTape';
import { useMarketingTheme } from './useMarketingTheme';
import './marketing.css';

// Marketing route group layout: own header/footer, independent of the logged-in AppShell.
export const MarketingLayout = ({ isHome = false, onAuth, children }) => {
  const [theme, toggleTheme] = useMarketingTheme();
  return (
    <div className="th-mkt" data-theme={theme} data-testid={isHome ? 'landing-page' : 'public-page'}>
      <a href="#main" className="mk-skip">Skip to content</a>
      <MarketingHeader isHome={isHome} onAuth={onAuth} theme={theme} onToggleTheme={toggleTheme} />
      <TickerTape />
      <main id="main" className="mk-main" tabIndex={-1}>{children}</main>
      <MarketingFooter />
    </div>
  );
};

export const goToAuth = (mode) => { window.location.href = `/?auth=${mode}`; };
